import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../../login/cliente_login";
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { ClienteXAseguradoraEntity } from "../entities/clientexseguradora_entity";
import { PolizasVencidasNoLiberadasEntity } from "../entities/polizas-vencidasnoLiberadas_entity";
import { ListaDiccionaryEntity } from "../../../../components/common/utils/entities/lista_dictionary_entity";


declare var jQuery: any;

@Injectable()
export class PolizasVencidasNoLiberadasService {
    usuario: ClienteLogin;
    userEmpresa: ClienteXCiudad;
    private url = "polizasNoLiberadas";

    constructor(public authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultarListaPolizasNoLiberadas(clienteXAseguradora: ClienteXAseguradoraEntity): Observable<PolizasVencidasNoLiberadasEntity[]> {
        let body = JSON.stringify(clienteXAseguradora);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaPolizasVencidasNoFree", body, options).map(this.extractData)
            .catch(this.handleError);

    }
    
     consultarListaAseguradorasXCliente(cliente: ClienteXCiudad): Observable<ListaDiccionaryEntity[]> {
        let body = JSON.stringify(cliente);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarAseguradorasXCliente", body, options).map(this.extractData)
            .catch(this.handleError);

    }
    
    consultarListaDetallePolizasVencidas(polizaVencida: PolizasVencidasNoLiberadasEntity): Observable<PolizasVencidasNoLiberadasEntity[]> {
        let body = JSON.stringify(polizaVencida);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaDetallePolizasVencidas", body, options).map(this.extractData)
            .catch(this.handleError);

    }
    
     private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/fianzas/polizasVencidasNoLiberadas/polizas-vencidasnoLiberadas.service.ts